// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c985a9e6","453":"3afc3d9b","455":"a5eba458","977":"813239da"}[chunkId] + ".chunk.js";
};